import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import {
  Typography, CardMedia, WithStyles,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import wifiThermostatImg from '../../assets/img/wifi_thermostat.png';
import styles from './styles';
import { WifiThermostat } from '../../redux/types/wifiThermostats';

type Props = {
  wifiThermostat: WifiThermostat;
} & WithStyles<typeof styles>;

/**
 * WifiThermostatWidget displays information about a WiFi thermostat
 * including serial number, type, property ID, and temperature.
 * @param {Props} props - Component props including the WifiThermostat data and styles
 * @returns {React.ReactElement} Rendered WifiThermostatWidget component
 */
const WifiThermostatWidget: React.FC<Props> = (props) => {
  const { classes, wifiThermostat } = props;

  return (
    <Card
      role="presentation"
      className={classes.card}
    >
      <div className={classes.iconWrapper}>
        <CardMedia
          className={classes.icon}
          image={wifiThermostatImg}
        />
      </div>
      <CardContent>
        <Typography className={classes.primaryText}>
          WiFi Thermostat Serial Number:
          &nbsp;
          <span className="serialNumber">{wifiThermostat.wifi_thermostat_serial_number}</span>
        </Typography>
        <Typography className={classes.secondaryText}>
          Property ID:
          &nbsp;
          <Link className={classes.link} onClick={(e) => e.stopPropagation()} to={`/properties/${wifiThermostat.property_id}`}>{wifiThermostat.property_id}</Link>
        </Typography>
      </CardContent>
    </Card>
  );
};

export default React.memo(WifiThermostatWidget);
